import TextInput, {TextInputWithoutContainer} from "../../component/TextInput/TextInput";
import {useState} from "react";
import Select, {SelectWithoutContainer} from "../../component/Select/Select";
import TextEditor, {TextEditorWithoutContainer} from "../../component/TextEditor/TextEditor";
import Modal from 'react-modal';
import Cropper from "react-easy-crop";
import ImageCropper from "../../component/ImageInput/ImageInput";
import ImageInput from "../../component/ImageInput/ImageInput";
import Default_User_Pic from "../../component/ImageInput/defaultUserPic.svg";
import TreeSelect, {TreeSelectWithoutContainer} from "../../component/TreeSelect/TreeSelect";
import {listToTree} from "../../assets/functions";
import {PickDateTime , PickDate, PickDateWithoutContainer} from "../../component/PickDate/PickDate";
import InputFileBase64, {InputFileBase64WithoutContainer} from "../../component/InputFileBase64/InputFileBase64";
import {SketchPicker} from "react-color";
import PickColor from "../../component/PickColor/PickColor";

const Test = () => {
    const [form , setForm] = useState({
        firstname : "",
        lastname : "",
        rowType : "DOUBLE",
        sex : ['MALE' , 'CUSTOM' ],
        text : "",
        categories : [3 , 6],
        file : "",
        color : ""
    });

    const rowTypeOptions = [
        {
            label : "تکی" ,
            value : "SINGLE" ,
        },{
            label : "دابل" ,
            value : "DOUBLE" ,
        },{
            label : "سه تایی" ,
            value : "TRIPLE" ,
        },{
            label : "خطی" ,
            value : "LINEAR" ,
        },
    ];
    const sexOptions = [
        {
            label : "مرد" ,
            value : "MALE" ,
        },{
            label : "زن" ,
            value : "FEMALE" ,
        },{
            label : "زن مرد" ,
            value : "SHEMALE" ,
        },{
            label : "دستی" ,
            value : "CUSTOM" ,
        },
    ];


    const changeForm = (key , value) => {
        const newForm = {...form , [key] : value }
        setForm(newForm);
        console.log(newForm);
    }

    const data = [
        {
            "label": "لوازم خانگی",
            "id": 1,
            "parentId" : null ,
        },{
            "label": "لوازم پخت و پز",
            "id" : 2 ,
            "parentId" : 1 ,
        },{
            "label": "سرخ کن",
            "id" : 3,
            "parentId" : 2 ,
        },{
            "label": "پلوپز",
            "id" : 4,
            "parentId" : 2 ,
        },{
            "label": "بخارپز",
            "id" : 5,
            "parentId" : 2 ,
        },{
            "label": "نوشیدنی ساز",
            "id" : 6,
            "parentId" : 1 ,
        },{
            "label": "اسپرسوساز" ,
            "id" : 7,
            "parentId" : 6 ,
        },{
            "label": "آب میوه گیری",
            "id" : 8,
            "parentId" : 6 ,
        },{
            "label": "مکمل بدنسازی",
            "id" : 9,
            "parentId" : null ,
        },{
            "label": "گینر و افزایش وزن",
            "id" : 10,
            "parentId" : 9 ,
        },{
            "label": "یو اس ان" ,
            "id" : 11,
            "parentId" : 10 ,
        },{
            "label": "ماسل تک" ,
            "id" : 12,
            "parentId" : 10 ,
        },
        {
            "label": "اپلاید نوتریشن" ,
            "id" : 13,
            "parentId" : 10 ,
        },
        {
            "label": "رول وان" ,
            "id" : 14,
            "parentId" : 10 ,
        }

    ];

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">افزودن پیج</h1>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <PickColor color={form.color} onChange={(value) => {
                        console.log(value);
                        changeForm("color", value)
                    } } />
                </div>

                <div className="col-md-6">
                    <InputFileBase64
                        label={"فایل"}
                        multiple={ false }
                        onChange={ (value) => {console.log(value)} } />
                </div>

                <div className="col-md-6">
                    <PickDateTime label={"تاریخ تولد"} onChange={(value) => {
                        console.log(value)}
                    } />
                </div>

                <div className="col-md-6">
                    <TextInput label={"نام"} id={"firstname"} value={form.firstname} onChange={(value) => {
                        changeForm("firstname", value)
                    }}/>
                </div>
                <div className="col-md-6">
                    <TextInput label={"نام خانوادگی"} id={"lastname"} value={form.lastname} onChange={(value) => {
                        changeForm("lastname", value)
                    }}/>
                </div>

                <div className="col-12">
                    <TextEditor label={"متن توضیح"} value={form.text} onChange={(value) => {
                        changeForm("text", value)
                    }}/>
                </div>

                <div className="col-md-2 image-input">
                    <ImageInput
                        // defaultPic={Default_User_Pic}
                        aspect={1}
                        onChange={async (base64) => {
                            console.log(base64);
                        }}
                    />
                </div>
            </div>




            <Select label={"نوع سطر"} options={rowTypeOptions} value={form.rowType} onChange={(value) => {
                changeForm("rowType", value)
            }}/>


            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <TreeSelectWithoutContainer label={"دسته بندی"} data={listToTree(data, form.categories)}
                                                        onChange={(value) => {
                                                            const newCategories = [...value];
                                                            changeForm("categories", newCategories);
                                                        }}/>
                        </div>

                        <div className="col-md-6">
                            <TextInputWithoutContainer label={"نام"} id={"firstname"} value={form.firstname}
                                                       onChange={(value) => {
                                                           changeForm("firstname", value)
                                                       }}/>
                        </div>
                        <div className="col-md-6">
                            <TextInputWithoutContainer label={"نام خانوادگی"} id={"lastname"}
                                                       value={form.lastname}
                                                       onChange={(value) => {
                                                           changeForm("lastname", value)
                                                       }}/>
                        </div>

                        <div className="col-md-8">
                            <SelectWithoutContainer multiple={true} label={"جنسیت"} options={sexOptions}
                                                    value={form.sex} onChange={(value) => {
                                changeForm("sex", value)
                            }}/>
                        </div>


                    </div>
                </div>
            </div>


        </div>
    );
}

export default Test;